module.exports = __webpack_public_path__ + "img/face.6773e6da.png";